import {PrFormControlOption} from '../../interfaces/process-reports/pr-form-control-option';
import {LightCustomer} from '../../interfaces/customers/light-customer';
import {LightCustomerFactory} from '../customers/light-customer-factory';
import {LightEmployeeFactory} from '../employees/light-employee-factory';

export class PrFormControlOptionFactory {

  /**
   *
   * @param prFormControlOption
   * @returns
   */
  public static fromObject(prFormControlOption: any): PrFormControlOption {
    return new class implements PrFormControlOption {
      id: number = prFormControlOption.id;
      label: string = prFormControlOption.label;
      prFormControlId: number = prFormControlOption.pr_form_control_id;
      value: any = prFormControlOption.value;
      customer: LightCustomer = prFormControlOption.customer ? LightCustomerFactory.fromObject(prFormControlOption.customer) : null;
      customerId: number = prFormControlOption.customer_id;
      employeeId: number = prFormControlOption.employee_id;
      employee: any = prFormControlOption.employee ? LightEmployeeFactory.fromObject(prFormControlOption.employee) : null;
      isDeactivated: boolean = prFormControlOption.is_deactivated;
      sort: number = prFormControlOption.sort ?? null;
      isDefault: boolean = prFormControlOption.is_default ?? false;
    };
  }

  /**
   *
   * @param prFormControlOptions
   * @returns
   */
  public static fromArray(prFormControlOptions: any[]): PrFormControlOption[] {
    return prFormControlOptions.map((_prFormControlOption: any) => PrFormControlOptionFactory.fromObject(_prFormControlOption));
  }

  /**
   *
   * @param prFormControlOption
   * @returns
   */
  public static toRemote(prFormControlOption: PrFormControlOption): any {
    return {
      id: prFormControlOption.id,
      label: prFormControlOption.label,
      pr_form_control_id: prFormControlOption.prFormControlId,
      value: prFormControlOption.value,
      customer_id: prFormControlOption.customerId,
      employee_id: prFormControlOption.employeeId,
      is_deactivated: prFormControlOption.isDeactivated,
      sort: prFormControlOption.sort ?? null,
      is_default: prFormControlOption.isDefault ?? false
    };
  }

  /**
   *
   * @returns
   */
  public static new(): PrFormControlOption {
    return new class implements PrFormControlOption {
      id: number = null;
      label: string = null;
      prFormControlId: number = null;
      value: any = null;
      customer: LightCustomer = null;
      customerId: number = null;
      employeeId: number = null;
      employee: any = null;
      isDeactivated: boolean = false;
      sort: number = null;
      isDefault: boolean = false;
    };
  }

}
